import { request } from '@/api/http';
import type {
  DeleteResult,
  Recipient,
  RecipientResolveChatIdResult,
  RecipientTestMessageResult,
  TelegramResolveResult,
} from '@/api/types';

export const recipientsService = {
  list: () => request<Recipient[]>('/recipients'),
  create: (body: object) =>
    request<Recipient>('/recipients', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: string, body: object) =>
    request<Recipient>(`/recipients/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  resolveChatId: (chat_id: string) =>
    request<RecipientResolveChatIdResult>('/recipients/resolve-chat-id', {
      method: 'POST',
      body: JSON.stringify({ chat_id }),
    }),
  resolveTelegram: (id: string) =>
    request<TelegramResolveResult>(`/recipients/${id}/resolve-telegram`, { method: 'POST' }),
  testTelegram: (id: string, text?: string) =>
    request<RecipientTestMessageResult>(`/recipients/${id}/test-message`, {
      method: 'POST',
      body: JSON.stringify({ text: text ?? 'Civic Alert test' }),
    }),
  delete: (id: string, opts?: { remove_subscriptions?: boolean }) => {
    const q = opts?.remove_subscriptions === false ? '?remove_subscriptions=false' : '';
    return request<DeleteResult>(`/recipients/${id}${q}`, { method: 'DELETE' });
  },
  disable: (id: string) =>
    request<DeleteResult>(`/recipients/${id}/disable`, { method: 'POST' }),
};
